import { Field } from 'redux-form';

import { TextField } from 'common/components/forms';
import { isPickupBy } from 'common/helpers/featureFlags';

const RombauerPickupBy = () => {
  if (!isPickupBy()) {
    return null;
  }
  return (
    <>
      <br />
      <Field
        name="pickup-by"
        component={TextField}
        label="Pickup Package By:"
      />
    </>
  );
};

export default RombauerPickupBy;
